import { render, staticRenderFns } from "./scroll-box2.vue?vue&type=template&id=91a44fcc&scoped=true&"
import script from "./scroll-box2.vue?vue&type=script&lang=js&"
export * from "./scroll-box2.vue?vue&type=script&lang=js&"
import style0 from "./scroll-box2.vue?vue&type=style&index=0&id=91a44fcc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "91a44fcc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/01-qym-hop-newmall-frontend-k8s@3/mgr-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('91a44fcc')) {
      api.createRecord('91a44fcc', component.options)
    } else {
      api.reload('91a44fcc', component.options)
    }
    module.hot.accept("./scroll-box2.vue?vue&type=template&id=91a44fcc&scoped=true&", function () {
      api.rerender('91a44fcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/chatLog/lib/scroll-box2.vue"
export default component.exports